<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-22 22:44:01
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-04-23 19:35:15
 * @Description: 
 -->
<template>
  <div class="op_panel_user">
    <div class="layer1">
      <img class="headimg" :src="sale.headimgurl" alt @click="clickHead" />
      <img
        class="btn_phone"
        :class="{open:isOpenMenu===true,close:isOpenMenu===false}"
        src="https://assets.rurushishi.com/yq-rs-make/vrdemo/op_panel_user/btn_phone.png"
        alt
      />
      <img
        class="btn_selecthouse"
        :class="{open:isOpenMenu===true,close:isOpenMenu===false}"
        src="https://assets.rurushishi.com/yq-rs-make/vrdemo/op_panel_user/btn_selecthouse.png"
        alt
      />
      <img
        class="btn_voice"
        :class="{open:isOpenMenu===true,close:isOpenMenu===false}"
        src="https://assets.rurushishi.com/yq-rs-make/vrdemo/op_panel_user/btn_voice.png"
        alt
      />
      <img
        class="btn_order"
        :class="{open:isOpenMenu===true,close:isOpenMenu===false}"
        src="https://assets.rurushishi.com/yq-rs-make/vrdemo/op_panel_user/btn_order.png"
        alt
      />
      <img
        class="btn_draw"
        :class="{open:isOpenMenu===true,close:isOpenMenu===false}"
        src="https://assets.rurushishi.com/yq-rs-make/vrdemo/op_panel_user/btn_draw.png"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      sale: {
        counselorname: "侯鹏许",
        counselornickname: "Aragorn",
        headimgurl:
          "https://assets.rurushishi.com/web6006/wx01f0b018d4951434/1587467399000-65.jpeg",
        mobile: "18321080158",
        saleropenid: "oj3y9wGThdLqhn0bZWOj7DeO2Tww"
      },
      isOpenMenu: undefined
    };
  },
  watch: {},
  computed: {},
  methods: {
    clickHead() {
      if (this.isOpenMenu === undefined || this.isOpenMenu === false) {
        this.isOpenMenu = true;
      } else if (this.isOpenMenu === true) {
        this.isOpenMenu = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.op_panel_user .headimg {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  position: fixed;
  right: 0.2rem;
  bottom: 5rem;
  border: 3px solid #305490;
  z-index: 2;
}
.op_panel_user .headimg.connect {
  border: 3px solid green;
}
.op_panel_user .btn_phone {
  position: fixed;
  z-index: 1;
  width: 0.5rem;
  height: 0.5rem;
  right: 0.55rem;
  bottom: 5.4rem;
}
.op_panel_user .btn_phone.open {
  animation: op_panel_user_kf_btn_phone_open;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}
.op_panel_user .btn_phone.close {
  animation: op_panel_user_kf_btn_phone_close;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes op_panel_user_kf_btn_phone_open {
  from {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
  to {
    width: 1.2rem;
    height: 1.2rem;
    right: 0.18rem;
    bottom: 6.7rem;
  }
}
@keyframes op_panel_user_kf_btn_phone_close {
  from {
    width: 1.2rem;
    height: 1.2rem;
    right: 0.18rem;
    bottom: 6.7rem;
  }
  to {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
}

.op_panel_user .btn_selecthouse {
  position: fixed;
  z-index: 1;
  width: 0.5rem;
  height: 0.5rem;
  right: 0.55rem;
  bottom: 5.4rem;
}
.op_panel_user .btn_selecthouse.open {
  animation: op_panel_user_kf_btn_selecthouse_open;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}
.op_panel_user .btn_selecthouse.close {
  animation: op_panel_user_kf_btn_selecthouse_close;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes op_panel_user_kf_btn_selecthouse_open {
  from {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
  to {
    width: 1.2rem;
    height: 1.2rem;
    right: 1.3rem;
    bottom: 6.1rem;
  }
}
@keyframes op_panel_user_kf_btn_selecthouse_close {
  from {
    width: 1.2rem;
    height: 1.2rem;
    right: 1.3rem;
    bottom: 6.1rem;
  }
  to {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
}

.op_panel_user .btn_voice {
  position: fixed;
  z-index: 1;
  width: 0.5rem;
  height: 0.5rem;
  right: 0.55rem;
  bottom: 5.4rem;
}
.op_panel_user .btn_voice.open {
  animation: op_panel_user_kf_btn_voice_open;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}
.op_panel_user .btn_voice.close {
  animation: op_panel_user_kf_btn_voice_close;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes op_panel_user_kf_btn_voice_open {
  from {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
  to {
    width: 1.2rem;
    height: 1.2rem;
    right: 2rem;
    bottom: 5rem;
  }
}
@keyframes op_panel_user_kf_btn_voice_close {
  from {
    width: 1.2rem;
    height: 1.2rem;
    right: 2rem;
    bottom: 5rem;
  }
  to {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
}

.op_panel_user .btn_order {
  position: fixed;
  z-index: 1;
  width: 0.5rem;
  height: 0.5rem;
  right: 0.55rem;
  bottom: 5.4rem;
}
.op_panel_user .btn_order.open {
  animation: op_panel_user_kf_btn_order_open;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}
.op_panel_user .btn_order.close {
  animation: op_panel_user_kf_btn_order_close;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes op_panel_user_kf_btn_order_open {
  from {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
  to {
    width: 1.2rem;
    height: 1.2rem;
    right: 1.3rem;
    bottom: 3.9rem;
  }
}
@keyframes op_panel_user_kf_btn_order_close {
  from {
    width: 1.2rem;
    height: 1.2rem;
    right: 1.3rem;
    bottom: 3.9rem;
  }
  to {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
}
.op_panel_user .btn_draw {
  position: fixed;
  z-index: 1;
  width: 0.5rem;
  height: 0.5rem;
  right: 0.55rem;
  bottom: 5.4rem;
}
.op_panel_user .btn_draw.open {
  animation: op_panel_user_kf_btn_draw_open;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}
.op_panel_user .btn_draw.close {
  animation: op_panel_user_kf_btn_draw_close;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes op_panel_user_kf_btn_draw_open {
  from {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
  to {
    width: 1.2rem;
    height: 1.2rem;
    right: 0.18rem;
    bottom: 3.3rem;
  }
}
@keyframes op_panel_user_kf_btn_draw_close {
  from {
    width: 1.2rem;
    height: 1.2rem;
    right: 0.18rem;
    bottom: 3.3rem;
  }
  to {
    width: 0.5rem;
    height: 0.5rem;
    right: 0.55rem;
    bottom: 5.4rem;
  }
}
</style>